import React from 'react'
import styled from 'styled-components'
import useShop from '../../context/AppContext'
import { Link } from 'react-router-dom'
import { images } from '../../constants'
import { IconTabs } from '../../assets/icons'
import { IconActive } from '../../assets/icons'

// styled
const ArticleCard = styled.article`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  width: 100%;
  height: 100%;
`
const ArticleInner = styled.div`
  display: flex;
  overflow: hidden;
  justify-content: space-between;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  width: 100%;
  height: 100%;
  padding: 30px;
  border-radius: 8px;
  background-color: var(--black-medium);
  box-shadow: 0 0 0 1px rgb(0 0 0 / 1%), 0 25px 25px rgb(0 0 0 / 3%), 0 15px 15px rgb(0 0 0 / 6%), 0 10px 8px rgb(0 0 0 / 5%), 0 4px 4px rgb(0 0 0 / 4%), 0 2px 2px rgb(0 0 0 / 3%);
  transition: var(--transition);
  .icon-active {
    position: absolute;
    right: 0;
    bottom: 0;
    &.shopify-support path {
      fill: var(--service-support);
    }
    &.shopify-design path {
      fill: var(--service-design);
    }
    &.shopify-marketing path {
      fill: var(--service-marketing);
    }
    &.shopify-development path {
      fill: var(--service-development);
    }
  }
  &:hover {
    transform: translateY(-7px);
    .article-title {
      .shopify-design {
        color: var(--service-design);
      }
      .shopify-development {
        color: var(--service-development);
      }
      .shopify-marketing {
        color: var(--service-marketing);
      }
      .shopify-support {
        color: var(--service-support);
      }
    }
  }
`
const ArticleHeader = styled.header`
  .article-icon {
    margin-bottom: 30px;
    &.shopify-design {
      svg.tab-icon {
        width: 52px;
        height: 52px;
        path {
          fill: var(--service-design);
        }
      }
    }
    &.shopify-development {
      svg.tab-icon {
        width: 52px;
        height: 52px;
        path {
          fill: var(--service-development);
        }
      }
    }
    &.shopify-marketing {
      svg.tab-icon {
        width: 52px;
        height: 52px;
        path {
          fill: var(--service-marketing);
        }
      }
    }
    &.shopify-support {
      svg.tab-icon {
        width: 52px;
        height: 52px;
        path {
          fill: var(--service-support);
        }
      }
    }
  }
  .article-title {
    font-family: var(--font-sans);
    font-size: var(--fz-l);
    margin-bottom: 12px;
    transition: var(--transition);
    a::before {
      content: '';
      display: block;
      position: absolute;
      z-index: 0;
      width: 100%;
      height: 100%;
      top: 0px;
      left: 0px;
    }
  }
  p {
    color: var(--text);
    line-height: 1.25;
  }
`
const ArticleFooter = styled.footer`
  display: flex;
  flex-direction: row;
  position: relative;
  align-items: center;
  margin: 40px 0 0;
`
const ShopifyIcon = styled.div`
  img {
    opacity: 0.9;
    width: 20px;
  }
`
const ShopifyService = styled.span`
  display: inline-block;
  margin-left: 10px;
  color: var(--text);
  font-size: var(--fz-xs);
  font-weight: 500;
  line-height: 1;
`

const ServiceCard = ({ id, url, icon, title, desc, service }) => {
  const { serviceId } = useShop()

  return (
    <ArticleCard className="article-card">
      <ArticleInner>
        {serviceId === id ? <IconActive service={icon} /> : ''}
        <ArticleHeader>
          <div className={`article-icon ${icon}`}>
            <IconTabs name={icon} />
          </div>
          <h3 className="article-title">
            <Link to={url} className={icon}>
              {title}
            </Link>
          </h3>
          <p>{desc}</p>
        </ArticleHeader>
        <ArticleFooter>
          <ShopifyIcon>
            <img src={images.service_card_shopify} alt="Shopify" />
          </ShopifyIcon>
          <ShopifyService>{service}</ShopifyService>
        </ArticleFooter>
      </ArticleInner>
    </ArticleCard>
  )
}

export default ServiceCard
